import { Page } from '@/components';
import MarketsTable from './MarketsTable';
import OverviewKpis from './OverviewKpis';
import HistoricGraphs from './HistoricGraphs';

export default function HomePage() {
  return (
    <Page>
      <OverviewKpis />
      <HistoricGraphs />
      <MarketsTable />
    </Page>
  );
}
